import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import type { Actions, Subjects } from "@adva/auth";
import { useAbility } from "@/hooks/use-ability";

export function AbilityRoute({
  action,
  subject,
  children,
}: {
  action: Actions;
  subject: Subjects;
  children: ReactNode;
}) {
  const ability = useAbility();
  if (!ability.can(action, subject)) {
    return <Navigate to="/forbidden" replace />;
  }
  return <>{children}</>;
}
